import React from 'react';
import { Button } from './ui/button';

const AmazonSection = ({ onOpenModal }) => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background Image - Modern Abstract */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://images.unsplash.com/photo-1688413708888-8368d1d99a15)`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#012169]/98 via-[#013d9e]/97 to-[#012169]/98"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-[#F97316] rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-72 h-72 bg-[#8B5CF6] rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Dark content backdrop for better text visibility */}
        <div className="bg-black/60 backdrop-blur-md rounded-3xl p-10 md:p-14 shadow-2xl border border-white/10">
          <div className="inline-block mb-6">
            <span className="text-[#F97316] text-base font-bold uppercase tracking-widest px-6 py-3 bg-[#F97316]/20 backdrop-blur-sm rounded-full border-2 border-[#F97316] shadow-lg">
              Protect Your Brand
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-white mb-8 tracking-tight">
            Ready to Secure Your Trademark?
          </h2>
          <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed font-light">
            Don't wait until someone else files your brand name. Get federal USPTO trademark registration with licensed IP attorneys. Protect your business identity, increase valuation, and gain exclusive nationwide rights—starting from just $45.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              onClick={() => onOpenModal && onOpenModal('Start Trademark Registration - CTA Section')}
              className="bg-gradient-to-r from-[#F97316] to-[#EA580C] hover:from-[#EA580C] hover:to-[#F97316] text-white font-bold px-10 py-7 text-lg rounded-xl shadow-2xl hover:shadow-[0_20px_60px_rgba(249,115,22,0.6)] transition-all duration-300 hover:scale-105"
            >
              Start Trademark Registration
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => onOpenModal && onOpenModal('Free Consultation - CTA Section')}
              className="border-2 border-white text-white hover:bg-white hover:text-[#012169] font-bold px-10 py-7 text-lg rounded-xl backdrop-blur-sm bg-white/10 shadow-xl transition-all duration-300 hover:scale-105"
            >
              Get Free Consultation
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AmazonSection;